
import React from 'react';
// import bill from '../assets/bill.png';         // deja los imports que ya tienes en tu archivo
// import devolution from '../assets/devolution.png';

const TransactionHistory = (props) => {
  // formateo original intacto
  let options = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = new Date(props.data.createdAt).toLocaleDateString('es-Es', options);
  const hour = props.data.createdAt.split('T')[1].split(':')[0] + ':' + props.data.createdAt.split('T')[1].split(':')[1] + ' ' + (props.data.createdAt.split('T')[1].split(':')[0] <= 11 ? 'AM' : 'PM');

  const isDevolution = props.data.order_type === 'devolution';

  return (
    <div
      className={`oc-card${isDevolution ? ' is-devolution' : ''}`}
      key={props.data.order_id}
    >
      {/* fila 1: chip "Orden #" + chip de estado */}
      <div className="oc-head">
        <span className="oc-chip oc-chip--order">
          <span className="oc-chip-media">
            {/* <img src={isDevolution ? devolution : bill} alt="" width="18" height="18" /> */}
          </span>
          <span className="oc-chip-k">Orden</span>
          <span className="oc-chip-v">#{props.data.transaction_code}</span>
        </span>
        <span className={`oc-chip oc-chip--status ${isDevolution ? 'is-devolution' : 'is-done'}`}>
          {isDevolution ? 'Devolución' : 'Realizada'}
          {isDevolution ? (
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
          ) : (
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          )}
        </span>
      </div>

      {/* fila 2: tipo + método de pago */}
      <div className="oc-meta">
        <span className="oc-user">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 12V8H6a2 2 0 0 1 0-4h12v4" /><path d="M4 6v12a2 2 0 0 0 2 2h14v-4" /><rect x="16" y="12" width="6" height="4" rx="1" />
          </svg>
          <span className="oc-user-name" style={{ textTransform: 'uppercase', letterSpacing: '.03em' }}>
            {props.data.order_type}
          </span>
        </span>
        <span className="oc-pill">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="6" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" />
          </svg>
          {props.data.paymenthod}
        </span>
      </div>

      {/* fila 3: fecha y hora en celdas */}
      <div className="oc-times">
        <div className="oc-time">
          <span className="oc-time-k">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
            Fecha
          </span>
          <span className="oc-time-v">
            <span className="oc-time-d">{date}</span>
          </span>
        </div>
        <div className="oc-time">
          <span className="oc-time-k">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
            Hora
          </span>
          <span className="oc-time-v">
            <span className="oc-time-d">{hour}</span>
          </span>
        </div>
      </div>

      {/* fila 4: total (esta card no tiene botón) */}
      <div className="oc-foot">
        <span className="oc-total oc-total--wide">
          <span className="oc-total-k">Total</span>
          <span className="oc-total-v">${props.data.total.toFixed(2)}</span>
        </span>
      </div>
    </div>
  );
};

export default TransactionHistory;